import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import FooterView from './view';
import locale from './locale';
import { LOCALE_KEY } from './const';
import { registerLocale } from '@/shared/helpers/language';
import { show, ContentType } from '@/apis/lib/content';
import useCurrentLanguage from '@shared/hooks/useCurrentLanguage';

const Footer = () => {
    const [initLoading, setInitLoading] = useState(true);
    const [content, setContent] = useState<ContentType | undefined>(undefined);
    const { currentLang } = useCurrentLanguage();
    const { i18n } = useTranslation(LOCALE_KEY);

    registerLocale(i18n, LOCALE_KEY, locale);

    useEffect(() => {
        getContent();
    }, []);

    const getContent = async () => {
        try {
            const response = await show({
                include:
                    'WorkdayInfo,WorkOfficeAddress,WorkCallNumber,WorkEmail,WorkFacebookAccount,WorkInstagramAccount,WorkWaNumber,WorkTwitterAccount',
            });
            // Handle both possible response structures: data.data or data
            const contentData = response.data?.data || response.data;
            console.log('Footer content data:', contentData); // Debug log
            setContent(contentData);
        } catch (err) {
            console.error('Error fetching footer content:', err);
        } finally {
            setInitLoading(false);
        }
    };

    return (
        <FooterView content={content} initLoading={initLoading} currentLang={currentLang || 'en'} />
    );
};

export default Footer;
